import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface GiftcardEditDialogData {
  giftcardId: string;
}

@Component({
  selector: 'azc-giftcard-edit-dialog',
  templateUrl: './giftcard-edit-dialog.component.html',
  styleUrls: ['./giftcard-edit-dialog.component.scss']
})
export class GiftcardEditDialogComponent implements OnInit {
  public iframeUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<GiftcardEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GiftcardEditDialogData,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    // URL to ac-giftcard-ui edit page
    // Adjust based on your environment (local, dev, stage, prod)
    const baseUrl = this.getGiftcardUIBaseUrl();
    const url = `${baseUrl}/?giftCardId=${this.data.giftcardId}`;
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    // Listen for messages from the iframe
    window.addEventListener('message', this.handleIframeMessage);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleIframeMessage);
  }

  private handleIframeMessage = (event: MessageEvent) => {
    if (event.data && typeof event.data === 'object') {
      switch (event.data.type) {
        case 'GIFTCARD_EDIT_CLOSE':
        case 'GIFTCARD_EDIT_SUCCESS':
          this.onClose();
          break;
      }
    }
  };

  private getGiftcardUIBaseUrl(): string {
    // Determine based on environment
    const hostname = window.location.hostname;
    
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return 'http://localhost:3000'; // Local ac-giftcard-ui
    } else if (hostname.includes('.stg.')) {
      return 'https://giftcard-ui.stg.amazingco.me';
    } else if (hostname.includes('.amazingco.me') && !hostname.includes('stg')) {
      return 'https://giftcard-ui.amazingco.me';
    } else {
      // Dev environment
      return 'https://giftcard-ui-dev.amazingco.me';
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
